import {Component, EventEmitter, Input, OnInit, OnChanges, Output, ViewEncapsulation} from '@angular/core';
import {Model} from '../../data/Model';
import {ModelsDataProvider} from '../../data/ModelsDataProvider';
import {SimulationSession} from '../../data/SimulationSession';
import * as aristoGlobals from '../../globals';
import {ModelGroup} from '../../data/ModelGroup';
import {AristoDialogComponent} from '../../aristo-dialog/aristo-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {TranslateService, DefaultLangChangeEvent} from '@ngx-translate/core';

@Component({
  selector: 'app-step2-model',
  templateUrl: './step2-model.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./step2-model.component.scss']
})
export class Step2ModelComponent implements OnInit, OnChanges {

  @Input() simulationSession!: SimulationSession;
  @Output() simulationSessionChange: EventEmitter<SimulationSession> = new EventEmitter<SimulationSession>();
  @Output() leftButton: EventEmitter<any> = new EventEmitter<any>();
  @Output() rightButton: EventEmitter<any> = new EventEmitter<any>();
  models: Model[] = [];
  showFrench = true;

  constructor(private modelsDataProvider: ModelsDataProvider, public dialog: MatDialog, public translate: TranslateService) {
  }

  ngOnChanges(changes: any) {
    console.log('changes');
    console.log(this.simulationSession.litrage);
  }

  ngOnInit(): void {

    this.showFrench = (this.translate.defaultLang === 'fr');
    console.log(this.translate.defaultLang);
    console.log(this.showFrench);
    this.translate.onDefaultLangChange.subscribe((event: DefaultLangChangeEvent) => {
      console.log(event.lang);
      this.showFrench = (event.lang === 'fr');
    });
  }

  public getModelImagePath(model: Model): string{
    return aristoGlobals.ARISTOMETRIX_LOCAL_IMG_HOST + model.img;
  }

  public getModels(): Model[] {
    const modelGroups: ModelGroup[] = this.modelsDataProvider.getModelsGroups();
    const selectedModelGroup = modelGroups.find(mg => mg.label === this.simulationSession.litrage + '');
    if (selectedModelGroup) {
      this.models = selectedModelGroup.models;
    }
    return this.models;
  }

  saveModel() {
    this.simulationSession.priceAriston = Number(this.simulationSession.model.price);
    this.simulationSessionChange.emit(this.simulationSession);
  }

  leftButtonClicked(){
    this.leftButton.emit();
  }

  rightButtonClicked(){
    if (this.isValid()) {
      this.rightButton.emit();
    }
  }

  isValid(): boolean {
    if (this.simulationSession.model && this.simulationSession.model.id.trim()) {
      return true;
    }
    else {
      this.dialog.open(AristoDialogComponent, { data: { dialogText: 'MESSAGES.ERRORS.MODEL_ERROR'}});
      return false;
    }
  }
}
